import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useLocation } from 'react-use';
import { postAsync } from '../../../components/helper/axiosHelper';
import { PageHitCountApi } from '../../../shared/Helper';



export const UserActivate = () => {
  const { activeGUID } = useParams();
  const [response, setResponse] = useState('');
  const { pathname } = useLocation();



  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, []);


  useEffect(() => {
    userverfied();
  }, []);

  const userverfied = async () => {
    await postAsync('EP_UserAuthentication/VerifyEPUser', {}, { id: activeGUID })
      .then((response) => {
        setResponse(response?.message);
        if (response.statusCode === 200 || response.statusCode === 208) {
          toast.success(`${t(response?.message)}`);
        }
        if (response.statusCode === 204) {
          toast.error(`${t(response?.message)}`);
        }
        window.location.href = '/donorLogin';

      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));

      });
  };
  return false
};
